// extracted by mini-css-extract-plugin
var _1 = "Background-vyGXy";
var _2 = "Outline-eolKL";
var _3 = "Shadow-IxNk5";
export { _1 as "Background", _2 as "Outline", _3 as "Shadow" }
